var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "popover-langs"
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('common.Input-Language-Name'),
      "size": "mini"
    },
    on: {
      "input": _vm.replayTranslate
    },
    model: {
      value: _vm.replayTranslateTitle,
      callback: function ($$v) {
        _vm.replayTranslateTitle = $$v;
      },
      expression: "replayTranslateTitle"
    }
  }), _c('div', {
    staticClass: "list"
  }, _vm._l(_vm.filterLangs, function (name, code) {
    return _c('div', {
      key: code,
      staticClass: "list-item",
      on: {
        "click": function ($event) {
          return _vm.langClick({
            name,
            code
          });
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.displayLanguageName(code, name)) + " ")]);
  }), 0)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };